// PlotTools are buttons a user can toggle to change how they interact
// with the plot panel.

export enum PlotTool {
  Move = "move",
  SelectRegion = "selectRegion",
}
